import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type AddTestUserResponseType = {};

export type TestUserParams =
  | {
      phone: string;
      nickname: string;
      franchise_owner_id?: number;
      email?: string;
      channel: 'sms';
    }
  | {
      channel: 'push';
      email: string;
      nickname: string;
      franchise_owner_id?: number;
    };

export const useAddTestUser = (
  options?: MutationOptions<
    AddTestUserResponseType,
    TestUserParams,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async ({ channel, ...userData }) => {
      const { data } = await api.post<ApiResponse<AddTestUserResponseType>>(
        channel === 'push' ? '/campaign/test-user-push' : '/campaign/test-user',
        userData
      );

      return data.data;
    },
    ...options,
  });
